import { Component } from '@angular/core';
import { Location } from '@angular/common';

import { AuthGuard } from './_guard/auth.guard';
import { AuthenticationService } from './_services/authentication.service';

import { Utente } from './_models/utente';
import { UserContext } from './_models/user-context';
import { Utils } from './utils';
import { Router, ActivatedRoute, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { HomepageComponent } from './components/homepage/homepage.component';
import { AppProperties } from './app-properties';
import { AppInjector } from './_helpers/app-injector';
import { RoutingParameterService } from './_services/routing-parameters.service';
import { ComponentBase } from './components/component-base.component';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'ArubaProvisioningWebFrontEnd';
  user: Utente;
  homePage: boolean = false;
  notFoundPage: boolean = false;
  componentName: string;

  footerFixed: boolean = false;

  constructor(
    protected route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private location: Location
  ) {

    this.router.events.subscribe((navigationEnd: NavigationEnd) => {
      if (navigationEnd instanceof NavigationEnd) {

        this.componentName = this.route.root.children[0].snapshot.data['componentName'] || "";
        this.homePage = this.componentName == 'homePage';
        this.notFoundPage = this.componentName == 'notFound';

        this.footerFixed = false;
      }
    });
  }

  previousPage() {
    this.location.back();
  }

  getBodyClassName() {
    return this.componentName;
  }

  isHomepage() {
    return this.homePage;
  }

  isUserLogged(): boolean {
    return Utils.isUserLogged() && !Utils.getUserContext().pwdChangeRequired;// && !Utils.getUserContext().authConfirmRequired;
  }

  isUserAmministratore(): boolean {
    return Utils.isUtenteAmministratore();
  }

  getUserContext(): UserContext {
    return Utils.getUserContext();
  }

  toLog(o) {
    console.log(o);
  }

  isFooterFixed(): boolean {
    return this.footerFixed;
  }


  logout() {
    // reset login status
    this.authenticationService.logout();

    if (!AppProperties.URL_REDIRECT_LOGOUT)
      this.router.navigate(['/login']);
    else
      document.location.href = AppProperties.URL_REDIRECT_LOGOUT;
  }

  getHomepageRoute(): string {
    return '/';
  }

  getSwVersion() {
    return AppProperties.VERSION;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts